import {
    RPM_ADDON_STATUS_ACTIVE,
    RPM_ADDON_STATUS_ELIGIBLE,
    RPM_ADDON_STATUS_NEW,
} from '../constants/other';

export const shouldShowRpmAddonProgramPill = (rpmAddonStatusId) => (
    rpmAddonStatusId === RPM_ADDON_STATUS_ELIGIBLE
    || rpmAddonStatusId === RPM_ADDON_STATUS_NEW
    || rpmAddonStatusId === RPM_ADDON_STATUS_ACTIVE
);

export const getRpmAddonProgramPillLabel = (rpmAddonStatusId) => {
    if (rpmAddonStatusId === RPM_ADDON_STATUS_ELIGIBLE) {
        return '+ RPM Eligible';
    }
    if (rpmAddonStatusId === RPM_ADDON_STATUS_NEW || rpmAddonStatusId === RPM_ADDON_STATUS_ACTIVE) {
        return '+ RPM';
    }
    return null;
};

export const shouldShowRpmDeviceTypeForLookup = (rpmAddonStatusId) => (
    rpmAddonStatusId === RPM_ADDON_STATUS_NEW
    || rpmAddonStatusId === RPM_ADDON_STATUS_ACTIVE
);

export const getTopProgramChipLabel = (patient) => {
    if (!patient) {
        return '';
    }

    if (patient.program_type === 'apcm') {
        if (patient.apcm_service_level) {
            return `APCM Level ${patient.apcm_service_level}`;
        }
        if (patient.apcm_eligible_level) {
            return `APCM Level ${patient.apcm_eligible_level}`;
        }
        return 'APCM';
    }

    if (patient.program_type === 'ccm') {
        return 'CCM';
    }

    return '';
};

export const getProgramChipStyle = (label) => ({
    background: label === 'CCM' ? '#337ab7' : '#5cb85c',
    border: label === 'CCM' ? '1px solid #337ab7' : '1px solid #5cb85c',
    borderRadius: 20,
    padding: '2px 12px',
    fontWeight: 400,
    fontSize: 12,
    color: '#FFFFFF',
    display: 'inline-block',
    whiteSpace: 'nowrap',
});

export const getRpmEligibleChipStyle = () => ({
    border: '2px solid #6b8fa3',
    background: '#eef3f6',
    color: '#3d5a6c',
    borderRadius: 20,
    padding: '2px 12px',
    fontWeight: 600,
    fontSize: 12,
    display: 'inline-block',
    whiteSpace: 'nowrap',
});

export const getProgramTypeCount = (programTypeCounts, programTypeId) => {
    const counts = programTypeCounts && programTypeCounts.counts
        ? programTypeCounts.counts
        : programTypeCounts;

    if (!Array.isArray(counts) || !counts.length) {
        return null;
    }

    const normalizedId = (programTypeId || 'all').toLowerCase();
    const entry = counts.find((item) => {
        const type = String(item.key || item.program_type || item.programType || 'all').toLowerCase();
        if (normalizedId === 'all') {
            return type === 'all' || type === '';
        }
        return type === normalizedId;
    });

    if (!entry) {
        return null;
    }

    const count = entry.value != null ? entry.value : (entry.count != null ? entry.count : entry.total);
    if (count == null || count === '') {
        return null;
    }

    const parsedCount = Number(count);
    return Number.isNaN(parsedCount) ? count : parsedCount;
};
